import React from "react";
import Modal from 'react-bootstrap4-modal';

class OutageModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true
        }
    }
    go= () => {
        window.location.href = '/buy/device';
    }
    close= () => {
        this.setState({
            visible : false
        });
    }
    render() {
        const PaddingStyle = {
            paddingLeft: "15px",
            paddingRight: "15px"
        };
        return (
            <Modal visible={this.state.visible} className="outage-modal" onClickBackdrop={this.close}>
                <div className="modal-header">
          <h5 className="modal-title">System Outage</h5>
        </div>
                <div className="modal-body">
                    <div style={PaddingStyle}>
                    We regret to inform you that our system is currently experiencing an unexpected outage. Our technical team is actively working to resolve the issue and restore normal operations as quickly as possible. During this time, the system is inaccessible, and all services are temporarily unavailable.
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary btn-sm" onClick={this.close}>
                        Close
                    </button>
                </div>
            </Modal>
        );
    }
}

export default OutageModal;



// WEBPACK FOOTER //
// ./src/layout/OutageModal.js